export default "__VITE_ASSET__5chl7idR__"